import { getAddress } from 'ethers'

import { modal } from '@/contexts'

export const useSignMessage = () => {
  const signMessage = async ({ message }: { message: string }) => {
    const address = await modal.getAddress()
    console.log('signmessage-address', address)
    if (!address) return
    const provider: any = await modal.getProvider('eip155')

    const signPromise = provider.request({
      method: 'personal_sign',
      params: [message, getAddress(address)],
    })

    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error('Signature request timed out. Please confirm in your wallet.'))
      }, 10000)
    })

    const signature = await Promise.race([signPromise, timeoutPromise])

    return signature
  }

  return {
    signMessage,
  }
}
